module.exports = __webpack_public_path__ + "media/images/posts/webpage-655a0989f16f95d9a2f3cc2927f81655.png";